import { useState } from "react";
import { useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ListItem from "@material-ui/core/ListItem";
import Parser from "html-react-parser";
import Button from "@material-ui/core/Button";
import moment from "moment";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

import { makeReduxUpdateToNotificationCount } from "../utils/helpers";
import useCustomMutation from "../../common/utils/CustomMutation";
import { updateNotification } from "../../common/components/Query/InAppNotificaficationQuery/inAppQuery";
import { successToastify } from "../../common/utils/Toastify";

const useStyle = makeStyles((theme) => ({
  section: (props) => ({
    minHeight: "unset",
    minWidth: !props.menu ? "300px" : "100%",
    padding: !props.menu ? "1rem" : "8px 5px 8px 0",
    fontFamily: "GT Eesti Pro Text",
    display: "flex",
    borderBottom: "0.5px solid #D7E2ED",
    "&:nth-child(odd)": {
      backgroundColor: "#FAFAFA",
    },
  }),
  badge: {
    width: "2px",
    minWidth: "0px",
    height: "12px",
    background: "#3465D4",
  },
  checkbox: {
    width: "2.5em !important",
  },
  logoBox: (props) => ({
    width: !props.menu ? "10%" : "12%",
    display: "flex",
    minHeight: "100%",
    justifyContent: "center",
    alignItems: !props.menu ? "center" : "flex-start",
    paddingTop: !props.menu ? "0" : "3px",
    "& img": {
      width: "250%",
    },
  }),
  avatarBox: (props) => ({
    padding: "1rem",
    width: !props.menu ? "4.5rem" : "2.5rem",
    height: !props.menu ? "4.5rem" : "2.5rem",
    borderRadius: "50%",
    background: "whitesmoke",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  listItem: (props) => ({
    width: !props.menu ? "100%" : "88%",
    paddingTop: "0",
    paddingBottom: "0",
  }),
  contentBox: (props) => ({
    display: "flex",
    flexDirection: "column",
    gap: !props.menu ? 5 : 0,
    width: "100%",
  }),
  taskBtn: (props) => ({
    minWidth: "fit-content",
    height: !props.menu ? "32px" : "26px",
    fontSize: !props.menu ? "12px" : "10px",
    background: "#2457C1",
  }),
}));

const NotificationItem = (props) => {
  const {
    key,
    history,
    title,
    createdAt,
    link,
    read,
    menu,
    type,
    description,
    id,
  } = props;
  const classes = useStyle((props = { menu }));
  const dateTime = moment(createdAt).format("ddd MMM DD YYYY, h:mm A");
  const [notificationID, setNotificationID] = useState({});
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const {
    inappReducer: { unreadNotificationCount },
  } = useSelector((state) => state);

  const toggleItem = () => {
    setNotificationID((prevState) => ({
      ...prevState,
      [id]: { toggle: !prevState?.[id]?.toggle ? true : false, [id]: true },
    }));
  };

  const readNotificationSuccess = async () => {
    const updatedUnreadNotificationCount = unreadNotificationCount - 1;
    await queryClient.invalidateQueries(["inAppNotificationBadgeCount"]);

    dispatch(
      makeReduxUpdateToNotificationCount(updatedUnreadNotificationCount)
    );

    successToastify("Notification read successfully");
  };

  const { mutate: readNotification } = useCustomMutation({
    apiFunc: updateNotification,
    onSuccess: readNotificationSuccess,
    enabled: !!id,
    retries: 0,
  });

  const handleReadNotification = async () => {
    if (!read && !notificationID?.[id]?.[id]) {
      await readNotification({ id });
      return;
    }
  };

  const handleGoToTask = async (link) => {
    await handleReadNotification();
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const parseTitle = () => {
    const content = Parser(title);
    const start = 0;
    const end = menu ? 53 : content.length;
    const extractChild = (
      <>
        {content
          .map((txt) =>
            typeof txt == "string" ? (
              <span>{txt}</span>
            ) : (
              <b>{txt?.props?.children}</b>
            )
          )
          .slice(start, end)}
        {menu ? "..." : ""}
      </>
    );

    return extractChild;
  };

  return (
    <Box className={classes.section} key={key}>
      <ListItem className={classes.listItem}>
        <Box className={classes.contentBox}>
          <Typography
            style={{
              fontSize: menu ? 12 : "",
            }}
            variant="body1"
            onClick={() => (menu ? history.push("./notifications") : null)}
          >
            {parseTitle()}
          </Typography>

          <Typography
            style={{
              fontSize: menu ? 10 : 12,
              color: "#888888",
            }}
            onClick={() => (menu ? history.push("./notifications") : null)}
          >{`${dateTime}`}</Typography>
          {!!notificationID?.[id]?.toggle && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Typography
                style={{ fontSize: menu ? 12 : 13, color: "gray" }}
                gutterBottom
              >
                <b>Type: </b> {type}
              </Typography>
              {description && (
                <Typography
                  style={{
                    wordBreak: "break-all",
                    fontSize: menu ? 12 : 13,
                    color: "gray",
                  }}
                  gutterBottom
                >
                  {Parser(description)}
                </Typography>
              )}
            </div>
          )}
        </Box>
      </ListItem>
      {link && (
        <Button
          onClick={() => handleGoToTask(link)}
          variant="contained"
          color="primary"
          size="small"
          className={classes.taskBtn}
          style={{
            textTransform: "none",
            alignItems: "center",
            marginLeft: "auto",
            marginTop: menu ? 2 : 0,
          }}
        >
          Go to Task
        </Button>
      )}

      <Box
        style={{
          marginTop: 4,
          marginLeft: 10,
        }}
      >
        <>
          {notificationID?.[id]?.toggle ? (
            <KeyboardArrowUpRoundedIcon
              style={{
                cursor: "pointer",
                marginLeft: "auto",
                fontSize: !menu ? 26 : 22,
              }}
              color="action"
              onClick={() => toggleItem()}
            />
          ) : (
            <KeyboardArrowDownRoundedIcon
              style={{
                cursor: "pointer",
                marginLeft: "auto",
                fontSize: !menu ? 26 : 22,
              }}
              color="action"
              onClick={() => {
                toggleItem();
                handleReadNotification();
              }}
            />
          )}
        </>
      </Box>
    </Box>
  );
};

export default NotificationItem;
